import { createSelector } from 'reselect';
import { SUCCEEDED } from '../constants/RequestStatusTypes';
export const getAutomation = state => state.automation;
export const getAutomationFetchSucceeded = createSelector([getAutomation], automation => automation.get('status') === SUCCEEDED);
export const getIsProcessingDeals = createSelector([getAutomation], automation => automation.get('isProcessingDeals'));